import { render } from "./OrgList.vue?vue&type=template&id=6b9f3bbc&ts=true"
import script from "./OrgList.vue?vue&type=script&lang=ts"
export * from "./OrgList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__